import React from 'react';
export function Hero() {
  return <section className="relative bg-[#0d4a45] overflow-hidden pt-20 pb-16 md:pb-24" data-id="element-260">
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-[#e8a0a0]/20 translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-261" />
      <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-[#c9a84c]/15 -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-262" />
      <div className="absolute top-1/2 left-1/4 w-32 h-32 rounded-full bg-[#e8a0a0]/10 pointer-events-none" data-id="element-263" />

      {/* Gold decorative lines */}
      <div className="absolute top-1/3 left-8 w-16 h-0.5 bg-[#c9a84c]/40 pointer-events-none" data-id="element-264" />
      <div className="absolute top-1/3 left-8 mt-2 w-10 h-0.5 bg-[#e8a0a0]/40 pointer-events-none" data-id="element-265" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6" data-id="element-266">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16" data-id="element-267">
          {/* Left: Copy */}
          <div className="flex-1 text-center lg:text-left" data-id="element-268">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-[#c9a84c]/20 border border-[#c9a84c]/40 rounded-full px-4 py-1.5 mb-6" data-id="element-269">
              <span className="text-[#e8c97a] text-xs font-dm font-semibold uppercase tracking-widest" data-id="element-270">
                Guía de Micro-Edición para Mamás en USA
              </span>
            </div>

            {/* Main headline */}
            <h1 className="font-playfair text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-4" data-id="element-271">
              ¿Atrapada entre el caos del hogar y la{' '}
              <span className="text-[#c9a84c] italic" data-id="element-272">
                falta de dinero propio?
              </span>
            </h1>

            {/* Subheadline */}
            <p className="font-dm text-white/80 text-lg md:text-xl leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0" data-id="element-273">
              El método para mamás latinas en USA que ganan{' '}
              <strong className="text-[#e8c97a]" data-id="element-274">$800+ al mes</strong> editando
              videos de 15 segundos — sin mostrar su cara, sin experiencia
              previa, desde el sofá.
            </p>

            {/* Trust badges */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-8" data-id="element-275">
              {['✓ Sin inventario', '✓ Sin cámara', '✓ Solo tu celular', '✓ 2 horas al día'].map(badge => <span key={badge} className="bg-white/10 border border-white/20 text-white/90 text-sm font-dm px-3 py-1.5 rounded-full" data-id="element-276">
                  {badge}
                </span>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start" data-id="element-277">
              <a href="#precio" className="bg-[#c9a84c] hover:bg-[#e8c97a] text-[#0d4a45] font-dm font-bold text-base px-8 py-4 rounded-full transition-all shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 text-center" data-id="element-278">
                ✨ Quiero mi guía por $6.36 →
              </a>
              <a href="#solucion" className="border border-white/40 hover:border-white/70 text-white font-dm font-medium text-base px-8 py-4 rounded-full transition-all text-center" data-id="element-279">
                Ver qué incluye ↓
              </a>
            </div>

            {/* Social proof micro */}
            <p className="mt-5 text-white/50 text-sm font-dm" data-id="element-280">
              🔒 Pago seguro · Acceso inmediato
            </p>
          </div>

          {/* Right: Product image */}
          <div className="flex-shrink-0 w-full max-w-sm lg:max-w-md" data-id="element-281">
            <div className="relative" data-id="element-282">
              <div className="absolute inset-0 bg-[#c9a84c]/20 rounded-2xl blur-2xl scale-95 pointer-events-none" data-id="element-283" />
              <img src="https://cdn.magicpatterns.com/uploads/sYCio2eLc3TrS795cZEAQD/REEL-MOM_ESTRATEGICA.png" alt="Reel-Mom Estratégica — Guía de Micro-Edición para Mamás en USA" className="relative rounded-2xl shadow-2xl w-full" data-id="element-284" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}